"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStripeTerminalLocationId = exports.canTapToPayBeInterac = exports.STRIPE_INTERAC_PRESENT_PAYMENT_METHOD_TYPE = exports.isTapToPaySupportedByCountry = exports.TAP_TO_PAY_SUPPORTED_BY_COUNTRY = void 0;
const country_1 = require("../enums/country");
// Adding a new country forces an explicit choice here, so opening a country never silently exposes Tap to Pay.
exports.TAP_TO_PAY_SUPPORTED_BY_COUNTRY = {
    [country_1.OrganizationCountry.Canada]: true,
    [country_1.OrganizationCountry.UnitedStates]: true,
    [country_1.OrganizationCountry.GreatBritain]: true,
    [country_1.OrganizationCountry.Australia]: true,
    [country_1.OrganizationCountry.NewZealand]: false,
    [country_1.OrganizationCountry.Ireland]: true,
    [country_1.OrganizationCountry.Germany]: true,
};
const isTapToPaySupportedByCountry = (country) => {
    if (!country) {
        return false;
    }
    return exports.TAP_TO_PAY_SUPPORTED_BY_COUNTRY[country] ?? false;
};
exports.isTapToPaySupportedByCountry = isTapToPaySupportedByCountry;
exports.STRIPE_INTERAC_PRESENT_PAYMENT_METHOD_TYPE = "interac_present";
const canTapToPayBeInterac = (country) => {
    return country === country_1.OrganizationCountry.Canada;
};
exports.canTapToPayBeInterac = canTapToPayBeInterac;
const STRIPE_TERMINAL_LOCATION_ID_BY_COUNTRY = {
    staging: {
        [country_1.OrganizationCountry.Canada]: "tml_Fxs8igZnLDhXaN",
        [country_1.OrganizationCountry.UnitedStates]: "tml_E9RGbwv9O59ZCk",
        [country_1.OrganizationCountry.GreatBritain]: "tml_GXbMXwOkMFPwak",
        [country_1.OrganizationCountry.Australia]: "tml_Ge7SQwDA25GqjD",
        [country_1.OrganizationCountry.Ireland]: "tml_GrLkTABmXTMKBy",
        [country_1.OrganizationCountry.Germany]: "tml_GrLkTABmXTMKBy",
    },
    production: {
        [country_1.OrganizationCountry.Canada]: "tml_Fxs8TATUxgnsvS",
        [country_1.OrganizationCountry.UnitedStates]: "tml_E9RIcQ2wgLwcFw",
        [country_1.OrganizationCountry.GreatBritain]: "tml_GXbMHQHodddVj7",
        [country_1.OrganizationCountry.Australia]: "tml_Ge7RwI8CQMF3RK",
        [country_1.OrganizationCountry.Ireland]: "tml_GrLjAQXQx8q2wb",
        [country_1.OrganizationCountry.Germany]: "tml_GrLjAQXQx8q2wb",
    },
};
const getStripeTerminalLocationId = (country, environment) => {
    const environmentKey = environment === "production" ? "production" : "staging";
    return STRIPE_TERMINAL_LOCATION_ID_BY_COUNTRY[environmentKey][country] ?? null;
};
exports.getStripeTerminalLocationId = getStripeTerminalLocationId;
